import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX, Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/shared/components/ui';

/**
 * UnauthorizedPage - Displayed when users try to access restricted areas
 * Shows a clear message and provides navigation options
 */
const UnauthorizedPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-8 text-center">
          {/* Icon */}
          <div className="w-16 h-16 bg-warning-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShieldX size={32} className="text-warning-600" />
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-neutral-900 mb-2">
            Access Denied
          </h1>

          {/* Message */}
          <p className="text-neutral-600 mb-6">
            You don't have permission to access this page. This area requires special privileges.
          </p>

          {/* Additional Info */}
          <div className="bg-neutral-50 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-neutral-700">
              <strong>What happened:</strong>
            </p>
            <ul className="text-sm text-neutral-600 mt-2 space-y-1 list-disc list-inside">
              <li>You tried to access a restricted page</li>
              <li>Your account doesn't have the required role</li>
              <li>This attempt has been logged for security</li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Link to="/client/dashboard">
              <Button variant="primary" className="w-full">
                <Home size={18} />
                Go to Dashboard
              </Button>
            </Link>
            <button
              onClick={() => window.history.back()}
              className="w-full px-4 py-3 rounded-xl border border-neutral-300 text-neutral-700 font-medium hover:bg-neutral-50 transition-colors flex items-center justify-center gap-2"
            >
              <ArrowLeft size={18} />
              Go Back
            </button>
          </div>

          {/* Help Text */}
          <p className="text-xs text-neutral-500 mt-6">
            If you believe this is an error, please contact your administrator.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
